import { motion } from "framer-motion";

export default function Chapter({ num, title, sub, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="mb-12"
      data-testid={testId}
    >
      <div className="flex items-center gap-4">
        <span className="font-mono text-sm font-semibold tracking-[0.3em] text-volt">{num}</span>
        <span className="h-px flex-1 bg-navy-border" />
      </div>
      <h2 className="mt-5 font-display text-5xl uppercase leading-none text-white sm:text-6xl">{title}</h2>
      {sub && <p className="mt-4 max-w-xl text-base text-slate-400">{sub}</p>}
    </motion.div>
  );
}
